import React from 'react';
import { Link } from 'react-router-dom';

function setTagColor(actionItem) {
	if (actionItem === 'Sign POA') {
		return 'yellow';
	} else if (actionItem === 'Complete License Survey') {
		return 'yellow';
	} else if (actionItem === 'Add Ownership Details') {
		return 'yellow';
	} else if (actionItem === 'Review License Application') {
		return 'yellow';
	} else if (actionItem === 'Report Revenue') {
		return 'green';
	} else if (actionItem === 'Sign Cancellation Form') {
		return 'red';
	}
}

export default function ActionItemTag(props) {
	// console.log('ActionItemTag', props);

	return (
		<Link
			to={props.url}
			state={{ propertyName: props.propertyName, fromDashboard: true }}
		>
			{props.isDisplayed && (
				<div
					key={props.actionItem}
					className={
						`bg-${setTagColor(
							props.actionItem
						)}-500 inline-block mt-2 m-1 px-3 py-1 rounded-md text-white` +
						(!props.isEnabled ? ` opacity-60` : ` hover:underline`)
					}
				>
					{props.actionItem}
				</div>
			)}
		</Link>
	);
}
